import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgMetricNodeCard } from "../../../molecules/KgMetricNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const MetricFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgMetricNodeCard
      name={data.title ?? ""}
      hasWarning={data.hasWarning}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default MetricFlowNode;
